<template>
  <section>       
    <TypeSolicitationTypeDocumentForm 
      v-if="typeSolicitationId" 
      :type-solicitation-id="typeSolicitationId"
      @added="fetchTypeSolicitationTypeDocuments"
    /> 

    <div class="mt-1 mb-1" />

    <v-data-table
      :headers="table.headers"
      :items="table.content"
      :items-per-page="5"
      :loading="table.isLoading"
      :options.sync="table.pagination"
      :server-items-length="table.total"
      :footer-props="{ 'items-per-page-options': [10, 20, 30, 40] }"
      class="elevation-0 row-pointer"
      @click:row="openFieldsModal"
    >
      <template v-slot:item.actions="{ item }">
        <v-icon
          small
          class="mr-2"
          color="red"
          @click.stop="openDeleteModal(item)"
        >
          delete
        </v-icon>
      </template>
    </v-data-table>

    <TypeSolicitationTypeDocumentDeleteModal
      v-if="deleteModal.isOpen"
      :item="deleteModal.item"
      @close="deleteModal.isOpen = false"
      @deleted="fetchTypeSolicitationTypeDocuments"
    />

    <TypeSolicitationTypeDocumentFieldsModal
      v-if="fieldsModal.isOpen"
      :document-type="fieldsModal.documentType"
      @close="fieldsModal.isOpen = false"
    />
  </section>
</template>

<script>
  import TipoPedidoService from '@/services/tipo-pedido.service';
  import TypeSolicitationTypeDocumentDeleteModal from './TypeSolicitationTypeDocumentDeleteModal.vue';
  import TypeSolicitationTypeDocumentFieldsModal from './TypeSolicitationTypeDocumentFieldsModal.vue';
  import TypeSolicitationTypeDocumentForm from './TypeSolicitationTypeDocumentForm.vue';

  export default {
    name: 'TypeSolicitationTypeDocumentList',

    components: {
      TypeSolicitationTypeDocumentDeleteModal,
      TypeSolicitationTypeDocumentFieldsModal,
      TypeSolicitationTypeDocumentForm
    },

    props: {
      typeSolicitationId: {
        type: Number,
        required: true,
      },
    },
  
    data: () => ({
      table: {
        headers: [
          {
            text: 'Nome',
            align: 'start',
            sortable: false,
            value: 'type_document.name'
          },
          {
            text: 'Código',
            align: 'start',
            sortable: false,
            value: 'type_document.key'
          },
          {
            text: 'Ações',
            align: 'start',
            sortable: false,
            value: 'actions',
            width: '100px'
          }
        ],
        content: [],
        total: 0,
        isLoading: false,
      },

      deleteModal: {
        isOpen: false,
        item: null,
      },

      fieldsModal: {
        isOpen: false,
        documentType: null,
      }
    }),

    watch: {
      'table.pagination': {
        handler() {
          this.fetchTypeSolicitationTypeDocuments()
        },
        deep: true
      },

      '$route.params.id'(newId, oldId) {      
        this.fetchTypeSolicitationTypeDocuments();
      }
    },

    methods: {    
      fetchTypeSolicitationTypeDocuments() {
        this.table.isLoading = true;
        TipoPedidoService
          .listDocumentTypes(this.typeSolicitationId, this.buildParams())
          .subscribe(({items, totalItems }) => {
            this.table.content = items;
            this.table.total = totalItems;
            this.table.isLoading = false;
          }, () => {
            this.table.isLoading = false;
          });
      },

      buildParams() {
        const { page, itemsPerPage } = this.table.pagination;
        
        return {
          page,
          per_page: itemsPerPage,
          sort: 'id:asc'          
        };
      },

      openDeleteModal(item) {
        this.deleteModal.item = item;
        this.deleteModal.isOpen = true;
      },

      openFieldsModal(item) {
        this.fieldsModal.documentType = item.type_document;
        this.fieldsModal.isOpen = true;
      },
    }
  }
</script>

<style lang="scss" scoped>
.row-pointer ::v-deep tbody tr {
  cursor: pointer;
}
</style>